export default __webpack_public_path__ + "media/images/jvqmap/marker/white-b5fb6a976f7625ec2bab721cc0c32bef.png";